<template>
  <div class="page-container">
    <div class="container">
      <div class="row clearfix" style="border: 2px solid black; width: 100%; margin-bottom: 0.5em">
        <strong>DEBUG:</strong>
        <!-- TODO: This should be replace with date-selector and timezone=null -->
        <el-date-picker
          size="mini"
          v-model="debugCurrentDateOverride"
          type="datetime"
           placeholder="Select date and time"
           @change="debugUpdateTime('debug', $event)"/>
        <!-- <el-button @click="debugUpdateTime('debug')" size="mini">Jump to time</el-button> -->
        <div v-if="debugCurrentDateOverride !== null">
          <span style="color: red; font-weight: bold;">
            * override active ({{debugCurrentDateOverride|fromNow}}) *
          </span>
          <el-button @click="debugUpdateTime('now')" size="mini" style="color: red; font-weight: bold;">
            DISABLE
          </el-button>
        </div>
        <strong style="margin: 0 2em">Time: {{currentTime|longTime}}</strong>
        <!-- <router-link to="/overview">Meine Ziele</router-link> -->
        <el-button style="float: right" size="mini">
          <font-awesome-icon icon="wrench" />
        </el-button>
      </div>
      <div class="row">
        <div class="col grid-content" style="max-width: 600px">
          <div style="max-width: 600px; min-width: 200px; border: 2px solid red; min-height: 200px">
            <Quote />
          </div>
          <div style="max-width: 600px; min-width: 200px; border: 2px solid green; min-height: 100px">
            TIMER
            <pre>activeSession: {{activeSession}}</pre>

            <div v-if="this.activeSession">
              <template v-if="activeSession.commitmentId && activeSession.goalId">
                <h4 style="margin-top: 2em">Selected effort:</h4>
                <!-- <InlineCommitment :commitment="effort_by_goal_id_and_effort_id( activeSession.goalId, activeSession.commitmentId)" /> -->
                <InlineCommitment :commitment="currentEffort" />
              </template>

              <template v-if="activeSession.goalId">
                <h4 style="margin-top: 2em">Commitment belongs to goal:</h4>
                <InlineGoal :goal_id="activeSession.goalId" />
              </template>

              <template v-if="activeSession.tscId">
                <h4 style="margin-top: 2em">Commitment is assigned to timeslot collection:</h4>
                <InlineTimeslotCollection :tsc_id="activeSession.tscId" />
              </template>
            </div>

            <PersonalTimer />
          </div>
          <div style="max-width: 600px; min-width: 200px; border: 2px solid green; min-height: 200px">
            CURRENT SESSION / SESSION MANAGER
            remainingTimeMinutes: {{remainingTimeMinutes}}
            <SessionManager :now="currentTime "/>
          </div>
          <div style="max-width: 600px; min-width: 200px; border: 2px solid yellow; min-height: 200px">
            MICROTASKS
          </div>
          <div style="max-width: 600px; min-width: 200px; border: 2px solid pink; min-height: 200px">
            TIMESLOT COLLECTIONS TODAY
          </div>
        </div>
        <div class="col grid-content" style="max-width: 600px; min-width: 200px;">
          <div style=" border: 2px solid red; height: 600px">
            DAYPLAN
            <PersonalCalendar :now="currentTime" />
            <!-- <GoogleCalendarTest /> -->
          </div>
          <div style=" border: 2px solid blue; min-height: 500px">
            TASKLIST
            <br>
            <pre>{{goalListSelection.map(item => item.label)}}</pre>
            <!--
            Select Goal
            <el-select v-model="selectedGoal" placeholder="Select">
              <el-option
                v-for="item in goalListSelection"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <template v-if="selectedGoal !== ''">
              <task-lane
                :key="selectedGoal"
                :goal="goal_by_id(selectedGoal)"
                :goal_id="selectedGoal"
                @drag-start="handleDragStart" />
            </template>
            -->
          </div>
          <div style=" border: 2px solid blue; min-height: 200px">
            SUCCCESSES
            <!-- <Successes /> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>{{ this.flattened_calendar_data_all }} </pre> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import PersonalTimer from "@/components/FocusPage/Elements/PersonalTimer";
import PersonalCalendar from "@/components/FocusPage/Elements/PersonalCalendar";
import SessionManager from "@/components/FocusPage/Elements/SessionManager";
// import GoogleCalendarTest from "@/components/FocusPage/Elements/GoogleCalendarTest";
import Quote from "@/components/FocusPage/Elements/Quote";
// import Successes from "@/components/FocusPage/Elements/Successes";
// import TaskLane from '@/components/LanePage/TaskLane';

// TODO: Move to componetns/FocusPage

import InlineCommitment from '@/components/Inline/InlineCommitment'
import InlineGoal from '@/components/Inline/InlineGoal'
import InlineTimeslotCollection from '@/components/Inline/InlineTimeslotCollection'

import moment from '@/moment-gp.js'

export default {
  name: 'FocusPage',
  data() {
    return {
      selectedGoal: '',
      debugCurrentDateOverride: null,
      timerId: null,
      timerValue: null,
      activeSession: null,
      scheduledSession: null,
      remainingTimeMinutes: null
    }
  },
  mounted() {
    this.start();
  },
  watch: {
    $route (to, from) {
      console.log("***** refresh timer *****");
        if ( to.name === 'focus' ) {
        this.update(true); // Don't wait 1 min
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },
  computed: {
    ...mapGetters("goal", [
      // "goal_by_id",
      // "goal_list_ids",
      // "goal_list_meta_ready_without_deleted",
      // "effort_by_goal_id_and_effort_id",
      "goal_list_meta_ready_with_deleted"
    ]),
    // ...mapGetters('timeslots', [
      // 'weekday_preferences_by_timeslot_collection_id_sorted',
      // 'exceptions_by_timeslot_collection_id_sorted',
      // 'flattened_calendar_data_all',
      // 'get_view_range_start',
    // ]),
    ...mapGetters('calendar', [
      'currently_planned_session'
    ]),

    currentTime() {
      return ( this.debugCurrentDateOverride === null )
             ? this.timerValue : this.debugCurrentDateOverride;
    },

    currentEffort() {
      console.log("currentEffort");
      // TODO: Check if this will be cached?
      if ( this.activeSession.goalId && this.activeSession.commitmentId ) {
        return this.$models.commitment.with({ goalId: this.activeSession.goalId }).subscribeNode( this.activeSession.commitmentId )
        // return this.effort_by_goal_id_and_effort_id( this.activeSession.goalId, this.activeSession.commitmentId)
      }
      return null;
    },

    goalListSelection() {
      // console.log(this.goal_list_meta_ready_with_deleted);
      return this.goal_list_meta_ready_with_deleted.map(goal =>
        ({ 'value': goal.id, 'label': goal.cachedName }));
    }
  },
  methods: {
    start() {
      // TODO: Deactive when page doenst have the focus
      this.timerId = setInterval(this.update, 1000);
      this.update(true); // Don't wait 1 min
    },

    update(firstUpdate) {
      this.timerValue = moment.currentTime(); // new Date();
      // TODO: We don't need to do this every seconds, actually it would be
      // enough to do it every 5 min, since not event won't start at 09:02
      // probably
      if ( this.timerValue.getSeconds() === 0 || firstUpdate) {
        /* Avoid excessiv updating. Only update every full minute */
        this.scheduledSession = this.currently_planned_session

        this.activeSession = this.scheduledSession; // HACK: ask user
      }
      if ( this.activeSession ) {
        let remainingTime = this.activeSession.userEnd.unix() - this.timerValue * 1e-3;
        this.remainingTimeMinutes = moment.duration( remainingTime, 'seconds' ).format();
      } else {
        this.remainingTimeMinutes = null;
      }
    },

    debugUpdateTime(action) {
      console.log("debugUpdateTime", this.debugCurrentDateOverride);

      switch (action) {
        case 'now':
        this.debugCurrentDateOverride = null;
        break;

        case 'debug':
        this.debugCurrentDateOverride = this.debugCurrentDateOverride;
        break;
      }
    }
  },
  components: {
    // PersonalTimer,
    SessionManager,
    PersonalCalendar,
    // GoogleCalendarTest,
    Quote,
    // Successes,
    // TaskLane,
    InlineCommitment,
    InlineGoal,
    InlineTimeslotCollection
  }
};
</script>

<style scoped>
.col {
  padding-left: 2px;
  padding-right: 2px;
}
.row {
  margin: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border: 1px solid red;
  border-radius: 4px;
  min-height: 36px;
}
</style>
